import { css } from "../../../styled-system/css";

export const pageCss = css({
  px: "20px",
  pt: "24px",
  pb: "104px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

export const sectionTitleCss = css({
  fontSize: "16px",
  lineHeight: "1.5",
  color: "text.primary",
});

export const panelCss = css({
  bg: "surface.primary",
  rounded: "16px",
  p: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

export const primaryButtonCss = css({
  minH: "48px",
  w: "full",
  bg: "surface.accentPrimary",
  color: "text.inverse",
  rounded: "12px",
  px: "24px",
  py: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "1.25",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.03)",
  _disabled: {
    bg: "surface.accentDisable",
    color: "text.inverse",
  },
});

export const secondaryButtonCss = css({
  minH: "48px",
  w: "full",
  bg: "#F8FAFC",
  border: "1px solid",
  borderColor: "border.secondary",
  color: "text.primary",
  rounded: "12px",
  px: "24px",
  py: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "1.25",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.03)",
  _disabled: {
    color: "text.disable",
  },
});

export const fieldCss = css({
  bg: "surface.primary",
  border: "1px solid",
  borderColor: "border.secondary",
  rounded: "12px",
  minH: "48px",
  px: "14px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.03)",
});

export const inputCss = css({
  w: "full",
  minW: 0,
  bg: "#FFFFFF",
  color: "text.primary",
  fontSize: "16px",
  lineHeight: "1.5",
  outline: "none",
  _placeholder: {
    color: "text.disable",
  },
});

export const helperTextCss = css({
  fontSize: "14px",
  lineHeight: "1.4",
  color: "text.secondary",
});

export const labelCss = css({
  fontSize: "14px",
  lineHeight: "1.4",
  fontWeight: "600",
  color: "text.secondary",
});
